import Logo from '../GCLOGO.png';
import React from 'react';
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { status } from '../hooks/AuthProvider';
import DownloadsNavLink from '../components/DownloadsNavLink';
import HeaderCTA from '../components/HeaderCTA';

type props = {};
type state = {
    loading: boolean;
    showingSolutions: boolean;
    isScrolled: boolean;
    isAuthenticated: boolean;
    isProductsOpen: boolean;
}

export class Header extends React.Component<props, state> {
    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            showingSolutions: false,
            isScrolled: false,
            isAuthenticated: false,
            isProductsOpen: false

        }
    }

    async componentDidMount() {
        const handleScroll = () => {
            this.setState({isScrolled: window.scrollY > 10});
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }

    setShowing(showing: boolean) {
        this.setState({showingSolutions: showing});
    }

    render() {
        return <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                this.state.isScrolled ? "bg-black/80 backdrop-blur-sm" : "bg-transparent"
            }`}
        >
            <div className="container mx-auto px-4">
                <div className="flex h-16 items-center justify-between">
                    <a href="/" className="flex items-center space-x-2 transition-opacity hover:opacity-80">
                        <img src={Logo} width={'200'} />
                        {/* <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        />
                        </svg>
                        <span className="text-xl font-bold">GuardedContent</span> */}
                    </a>

                    {/* New middle section with dropdowns */}
                    <nav className="hidden md:flex items-center space-x-6">
                        <div className="relative">
                            <Popover
                                onMouseEnter={() => this.setShowing(true)}
                                onMouseLeave={() => this.setShowing(false)}
                            >
                                <PopoverButton className="text-white hover:text-red-500 transition-colors flex items-center">Solutions</PopoverButton>
                                <Transition
                                    enter="transition ease-out duration-200"
                                    enterFrom="opacity-0 translate-y-1"
                                    enterTo="opacity-100 translate-y-0"
                                    leave="transition ease-in duration-150"
                                    leaveFrom="opacity-100 translate-y-0"
                                    leaveTo="opacity-0 translate-y-1"
                                    show={this.state.showingSolutions}
                                >
                                    <PopoverPanel
                                    anchor="bottom"
                                    className={`divide-y divide-white/5 rounded-xl bg-black/80 backdrop-blur-sm text-sm/6 [--anchor-gap:var(--spacing-5)] mt-2`}
                                    >
                                    <div className="p-3">
                                        <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="./#features">
                                            <p className="font-semibold text-white">General Media</p>
                                            <p className="text-white/50">Protect your content using DRM</p>
                                        </a>
                                        {/* <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                            <p className="font-semibold text-white">Music</p>
                                            <p className="text-white/50">Protect your music using DRM</p>
                                        </a>
                                        <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                            <p className="font-semibold text-white">Corporate Documents</p>
                                            <p className="text-white/50">Protect your documents using DRM</p>
                                        </a> */}
                                    </div>
                                    {/* <div className="p-3">
                                        <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                        <p className="font-semibold text-white">Documentation</p>
                                        <p className="text-white/50">Start integrating products and tools</p>
                                        </a>
                                    </div> */}
                                    </PopoverPanel>
                                </Transition>
                            </Popover>
                            {/* <button
                                // onClick={() => this.setIsProductsOpen(!this.state.isProductsOpen)}
                                onClick={() => this.setState({ isProductsOpen: !this.state.isProductsOpen })}
                                className="text-white hover:text-red-500 transition-colors flex items-center"
                            >
                                Products
                                <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button> */}
                        {/* {this.state.isProductsOpen && (
                            <div className="absolute top-full left-0 mt-2 w-56 bg-gray-900 border border-gray-800 rounded-md shadow-lg">
                                <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Content Creation Suite</a>
                                <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Analytics Dashboard</a>
                                <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Collaboration Tools</a>
                            </div>
                        )} */}
                        </div>
                        {/* <a href="/pricing" className="text-white hover:text-red-500 transition-colors">Pricing</a> */}
                        <DownloadsNavLink />
                    </nav>

                    <nav className="flex items-center gap-4">
                        <HeaderCTA />
                    </nav>
                </div>
            </div>
        </header>
    }
}


export default function Privacy() {
    return <>
        <Header />

        <div className="p-20">
          <h2 className="text-6xl text-center">
              <strong>Privacy Policy</strong>
          </h2>
          <p className="text-center mt-4">Effective Date: 23 February 2026</p>
          <p className="text-center">Last Updated: 23 February 2026</p>
          <br />

          <h3 className="text-4xl">1. Introduction</h3><br />
          <p>GuardedContent Pty Ltd (&ldquo;GuardedContent&rdquo;, &ldquo;we&rdquo;, &ldquo;our&rdquo;, or &ldquo;us&rdquo;) is an Australian company that operates a digital content marketplace and streaming platform for creators and subscribers. We are committed to protecting your privacy and handling personal information in accordance with the Australian Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs), and, where applicable, the EU/UK GDPR and other international privacy laws.</p>
          <p className="mt-4">This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our websites, mobile applications, and related services (collectively, the &ldquo;Platform&rdquo;).</p>
          <p className="mt-4">By using the Platform, you agree to the terms of this Privacy Policy.</p>

          <br /><h3 className="text-4xl">2. Data Controller and Contact Details</h3><br />
          <p><strong>Entity:</strong> GuardedContent Pty Ltd</p>
          <p><strong>Country:</strong> Australia</p>
          <p><strong>Email:</strong> <a href="mailto:support@guardedcontent.com" className="text-blue-500">support@guardedcontent.com</a></p>
          <p className="mt-4">GuardedContent Pty Ltd is the data controller for personal information collected through the Platform.</p>

          <br /><h3 className="text-4xl">3. Information We Collect</h3><br />

          <div className="px-4">
            <h4 className="text-3xl font-semibold">3.1 Personal Information You Provide</h4><br />
            <p>We may collect personal information that you provide directly, including:</p>
            <ul className="list-disc list-inside mt-2">
              <li>Name and display name</li>
              <li>Email address</li>
              <li>Phone number (if provided)</li>
              <li>Username and account credentials (hashed passwords)</li>
              <li>Billing and payment-related information (processed via third-party providers)</li>
              <li>Creator profile details and payout information</li>
              <li>Tax information (e.g., ABN or other registration numbers, where required)</li>
              <li>Communications with us (support tickets, emails, feedback)</li>
              <li>User-generated content (posts, media uploads, messages, reactions)</li>
            </ul>

            <br /><h4 className="text-3xl font-semibold">3.2 Payment Information</h4><br />
            <p>Payments on the Platform are processed by third-party payment processors such as Stripe. We do not store full credit or debit card numbers on our servers. Payment data is handled in accordance with the payment processor&rsquo;s privacy and security policies.</p>

            <br /><h4 className="text-3xl font-semibold">3.3 Automatically Collected Information</h4><br />
            <p>When you use the Platform, we may automatically collect:</p>
            <ul className="list-disc list-inside mt-2">
              <li>IP address</li>
              <li>Device identifiers and device type</li>
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>App usage and interaction data</li>
              <li>Log files and crash reports</li>
              <li>Approximate location (based on IP)</li>
            </ul>

            <br /><h4 className="text-3xl font-semibold">3.4 Security, DRM, and Anti-Fraud Data</h4><br />
            <p>To protect licensed content and prevent unauthorized access, we may collect technical playback and device information, including:</p>
            <ul className="list-disc list-inside mt-2">
              <li>DRM license request data</li>
              <li>Device and session identifiers</li>
              <li>Playback events and streaming telemetry</li>
              <li>Indicators used to detect account sharing, fraud, or abuse</li>
            </ul>
            <p className="mt-2">This information is used solely for security, content protection, and service integrity purposes.</p>

            <br /><h4 className="text-3xl font-semibold">3.5 Cookies and Tracking Technologies</h4><br />
            <p>We use cookies, local storage, and similar technologies to:</p>
            <ul className="list-disc list-inside mt-2">
              <li>Maintain user sessions and authentication</li>
              <li>Remember preferences and settings</li>
              <li>Analyse usage patterns and improve the Platform</li>
              <li>Enhance security and fraud detection</li>
            </ul>
            <p className="mt-2">You can manage cookie preferences through your browser settings, but disabling certain cookies may impact functionality.</p>
          </div>

          <br /><h3 className="text-4xl">4. How We Use Your Information</h3><br />
          <p>We use personal information to:</p>
          <ul className="list-disc list-inside mt-2">
            <li>Provide, operate, and maintain the Platform</li>
            <li>Authenticate users and manage accounts</li>
            <li>Process payments and subscriptions</li>
            <li>Deliver purchased or subscribed content</li>
            <li>Personalise and improve user experience</li>
            <li>Communicate updates, service notices, and support responses</li>
            <li>Send marketing communications (where permitted by law or consented)</li>
            <li>Monitor usage, performance, and reliability</li>
            <li>Detect, prevent, and investigate fraud, abuse, and unauthorized access</li>
            <li>Enforce our Terms of Service and content protection policies</li>
            <li>Comply with legal and regulatory obligations (including tax compliance)</li>
          </ul>

          <br /><h3 className="text-4xl">5. Legal Bases for Processing (Where Applicable)</h3><br />
          <p>Where GDPR or similar laws apply, we rely on the following legal bases:</p>
          <ul className="list-disc list-inside mt-2">
            <li><strong>Contract performance:</strong> to provide the Platform and process transactions</li>
            <li><strong>Legitimate interests:</strong> platform security, fraud prevention, DRM enforcement, and service improvement</li>
            <li><strong>Legal obligations:</strong> compliance with tax, financial reporting, and regulatory requirements</li>
            <li><strong>Consent:</strong> marketing communications and optional features where required</li>
          </ul>

          <br /><h3 className="text-4xl">6. How We Share Information</h3><br />
          <p>We do not sell personal information to third parties. We may disclose personal information in the following circumstances:</p>

          <div className="px-4 mt-4">
            <h4 className="text-3xl font-semibold">6.1 Service Providers</h4><br />
            <p>We share information with trusted third-party providers who assist in operating the Platform, including:</p>
            <ul className="list-disc list-inside mt-2">
              <li>Payment processors (e.g., Stripe)</li>
              <li>Cloud hosting and infrastructure providers (e.g., AWS)</li>
              <li>Analytics and monitoring services</li>
              <li>Customer support and communication tools</li>
              <li>Content delivery and DRM technology providers</li>
            </ul>
            <p className="mt-2">These providers are contractually required to protect personal information and use it only for authorized purposes.</p>

            <br /><h4 className="text-3xl font-semibold">6.2 Legal and Compliance</h4><br />
            <p>We may disclose information:</p>
            <ul className="list-disc list-inside mt-2">
              <li>To comply with applicable laws or legal processes</li>
              <li>To respond to lawful requests by public authorities</li>
              <li>To enforce our Terms and protect our rights, property, and users</li>
            </ul>

            <br /><h4 className="text-3xl font-semibold">6.3 Business Transfers</h4><br />
            <p>If we undergo a merger, acquisition, or asset sale, personal information may be transferred as part of that transaction, subject to applicable privacy safeguards.</p>
          </div>

          <br /><h3 className="text-4xl">7. International Data Transfers</h3><br />
          <p>Our Platform may transfer and process personal information in countries outside Australia, including the United States and the European Union, where our service providers and infrastructure are located.</p>
          <p className="mt-4">Where required, we take reasonable steps to ensure that overseas recipients handle personal information in accordance with applicable privacy laws and appropriate safeguards.</p>

          <br /><h3 className="text-4xl">8. Data Retention</h3><br />
          <p>We retain personal information only for as long as necessary to:</p>
          <ul className="list-disc list-inside mt-2">
            <li>Provide the Platform and services</li>
            <li>Maintain account records and transaction histories</li>
            <li>Comply with legal, tax, and accounting obligations</li>
            <li>Resolve disputes and enforce agreements</li>
            <li>Maintain security and anti-fraud records</li>
          </ul>
          <p className="mt-4">When personal information is no longer required, we will take reasonable steps to delete or de-identify it, subject to legal retention requirements.</p>

          <br /><h3 className="text-4xl">9. Data Security</h3><br />
          <p>We implement appropriate technical and organizational measures to protect personal information from unauthorized access, loss, misuse, alteration, or disclosure. These measures include access controls, encryption, secure infrastructure, and monitoring systems.</p>
          <p className="mt-4">However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.</p>

          <br /><h3 className="text-4xl">10. Your Rights and Choices</h3><br />
          <p>Depending on your jurisdiction, you may have rights to:</p>
          <ul className="list-disc list-inside mt-2">
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate or outdated information</li>
            <li>Request deletion of personal information (subject to legal exceptions)</li>
            <li>Object to or restrict certain processing activities</li>
            <li>Withdraw consent for marketing communications</li>
            <li>Request a copy of your data in a portable format (where applicable)</li>
          </ul>
          <p className="mt-4">To exercise your rights, contact us at <a href="mailto:support@guardedcontent.com" className="text-blue-500">support@guardedcontent.com</a>.</p>
          <p className="mt-2">We may need to verify your identity before fulfilling requests.</p>

          <br /><h3 className="text-4xl">11. Creator and User-Generated Content</h3><br />
          <p>Content you upload or publish on the Platform (including media, posts, and messages) may be visible to other users according to your privacy and access settings. Please ensure you only share content you are comfortable making available under those settings.</p>

          <br /><h3 className="text-4xl">12. Children&rsquo;s Privacy</h3><br />
          <p>The Platform is not directed to children under the age of 13 (or higher age thresholds required by applicable law). We do not knowingly collect personal information from children without appropriate consent. If we become aware that a child has provided personal information, we will take steps to delete it.</p>

          <br /><h3 className="text-4xl">13. Third-Party Links and Services</h3><br />
          <p>The Platform may contain links to third-party websites or services. We are not responsible for the privacy practices or content of these third parties. We encourage you to review their privacy policies before providing personal information.</p>

          <br /><h3 className="text-4xl">14. Changes to This Privacy Policy</h3><br />
          <p>We may update this Privacy Policy from time to time to reflect changes in our practices, technology, or legal requirements. We will post the updated version on the Platform and revise the &ldquo;Last Updated&rdquo; date. Continued use of the Platform after changes indicates acceptance of the updated policy.</p>

          <br /><h3 className="text-4xl">15. Contact Us</h3><br />
          <p>If you have any questions, concerns, or complaints about this Privacy Policy or our privacy practices, please contact:</p>
          <p className="mt-4"><strong>GuardedContent Pty Ltd</strong><br />
          Email: <a href="mailto:support@guardedcontent.com" className="text-blue-500">support@guardedcontent.com</a></p>
          <p className="mt-4">We will respond to privacy inquiries within a reasonable timeframe in accordance with applicable laws.</p>
        </div>

        <footer className="px-8 py-8 absolute left-0 bottom-0 right-0">
            © GuardedContent Pty Ltd 2026
        </footer>
    </>
}